module.exports = __webpack_public_path__ + "01db04c538886acac70fa223164f101e.pdf";